const validate = (values) => {
    let _errors = {};

    return _errors;
};

export default validate;